// Organisation display formats (OR-10, PD-056): date style and clock applied by every client.
export const DATE_STYLES = ['medium', 'long', 'numeric', 'iso'] as const;
export type DateStyle = (typeof DATE_STYLES)[number];
export const HOUR_CYCLES = ['locale', 'h23', 'h12'] as const;
export type HourCycle = (typeof HOUR_CYCLES)[number];
export interface DisplayFormat {
  readonly dateStyle: DateStyle;
  readonly hourCycle: HourCycle;
}
export const DEFAULT_DISPLAY_FORMAT: DisplayFormat = { dateStyle: 'medium', hourCycle: 'locale' };

/** Intl options for a date (and optionally time) under the organisation's display format. */
export function dateTimeOptions(f: DisplayFormat, withTime: boolean): Intl.DateTimeFormatOptions {
  const hc = f.hourCycle === 'locale' ? {} : { hourCycle: f.hourCycle };
  const time: Intl.DateTimeFormatOptions = withTime ? { hour: '2-digit', minute: '2-digit', ...hc } : {};
  switch (f.dateStyle) {
    case 'numeric':
      return { day: '2-digit', month: '2-digit', year: 'numeric', ...time };
    case 'iso':
      // Year-month-day order regardless of language (formatted by the caller with a y-m-d locale).
      return { year: 'numeric', month: '2-digit', day: '2-digit', ...time };
    case 'long':
      return withTime ? { dateStyle: 'long', timeStyle: 'short', ...hc } : { dateStyle: 'long' };
    default:
      return withTime ? { dateStyle: 'medium', timeStyle: 'short', ...hc } : { dateStyle: 'medium' };
  }
}
